import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import {
  UpdatePerformanceRuleStatus,
  UpdatePerformanceRuleStatusVariables
} from './__generated__/UpdatePerformanceRuleStatus';

const UPDATE_PERFORMANCE_RULE_STATUS_MUTATION = gql`
  mutation UpdatePerformanceRuleStatusMutation($status: StatusEnum!, $id: ID!) {
    updatePerformanceRuleStatus(status: $status, id: $id) {
      performanceRule {
        id
        name
        level
        evaluationSpec
        status
        createdBy
        triggered
        executionSpec
        campaign {
          id
          name
        }

        createdAt
        updatedAt
        triggeredAt
        articleIds
        ruleActivities {
          id
          activity
          details
          createdBy
          createdAt
        }
      }
      errors
    }
  }
`;

export const useUpdatePerformanceRuleStatusMutation = () => {
  return useMutation<UpdatePerformanceRuleStatus, UpdatePerformanceRuleStatusVariables>(
    UPDATE_PERFORMANCE_RULE_STATUS_MUTATION,
    { client: kmsClient }
  );
};
